import React from 'react'
import { useSelector } from 'react-redux'
import { Card } from '../components/index'

const Favorites = () => {
    const favorites = useSelector((state) => state.favorites)
    return (
        <>
        <div className="text-center mt-3">
            <h1 style={{color:"white"}}>Your Favorite Jokes !</h1>
        </div>
        <div className="row justify-content-center">
            {
                favorites.map((joke) => (
                    <Card
                    key={joke.id}
                    joke={joke}
                    />
                ))
            }
        </div>
        </>
    )
}

export default Favorites